module.exports = __webpack_public_path__ + "img/om.86155970.svg";